import firebase from 'firebase/compat/app';
import { getAuth, onAuthStateChanged, EmailAuthProvider } from 'firebase/auth';
import config from '../../../config/app.config';
import AppStore from '../../stores/AppStore';
import AuthStore from '../../stores/AuthStore';
import ProfileStore from '../../stores/ProfileStore';
import FavoriteStore from '../../stores/FavoriteStore';
import BaseHttp from '../BaseHttp';
import CookieUtils from '../../framework/utils/CookieUtils';
import { parseJWT } from '../../framework/utils/FirebaseUtils';
import { LOCAL_STORAGE_KEY } from '../../framework/constants/app';
import { ShowNotificationError } from 'framework/ErrorLogger';
if (!firebase.apps.length) {
    firebase.initializeApp(config.firebase);
}
const firebaseApp = firebase.initializeApp(config.firebase);
const auth = getAuth(firebaseApp);
// In this function do all things what you need after token update
const tokenUpdateAffect = (token) => {
    const firebaseUser = parseJWT(token);
    AuthStore.updateUserState(firebaseUser);
    localStorage.setItem(LOCAL_STORAGE_KEY.JWT_USER_NAME_KEY, firebaseUser.email);
    if (firebaseUser.name && firebaseUser.name !== '') {
        localStorage.setItem(LOCAL_STORAGE_KEY.JWT_DISPLAY_NAME_KEY, firebaseUser.name);
    }
    if (AuthStore.isDealerMain) {
        localStorage.setItem(LOCAL_STORAGE_KEY.JWT_IS_ADMIN_KEY, 'true');
    }
};
const doSignIn = (user) => {
    user.getIdToken(false).then((token) => {
        const firebaseUser = parseJWT(token);
        const favoritesCount = FavoriteStore.favoritesIDs.length;
        CookieUtils.setUserID(firebaseUser.user_id);
        console.group('AUTH_STATE_CHANGED');
        console.log('FIREBASE_USER: ', firebaseUser);
        console.groupEnd();
        BaseHttp.setHeaders({
            'Accept-Language': AppStore.language
        });
        // fetch data for an authorized user (w/ jwt)
        tokenUpdateAffect(token);
        if (favoritesCount > 0) {
            FavoriteStore.moveFavoritesToUserAccount().then(() => FavoriteStore.getFavoritesIDs()).catch(() => {
                ShowNotificationError();
            });
        }
        else {
            FavoriteStore.getFavoritesIDs();
        }
        ProfileStore.getProfileData();
        if (AuthStore.isDealerMain) {
            ProfileStore.getDealerProfile();
        }
        else {
            ProfileStore.getDealers();
        }
    });
};
const doSignOut = (user) => {
    console.group('AUTH_STATE_CHANGED');
    console.log('FIREBASE_USER', user);
    console.groupEnd();
    // Remove user name from local storage
    localStorage.removeItem(LOCAL_STORAGE_KEY.JWT_USER_NAME_KEY);
    localStorage.removeItem(LOCAL_STORAGE_KEY.JWT_IS_ADMIN_KEY);
    localStorage.removeItem(LOCAL_STORAGE_KEY.JWT_DISPLAY_NAME_KEY);
    // Remove userId from cookies
    CookieUtils.removeUserID();
    // Clear all stores related with auth
    AuthStore.clearUserState();
    ProfileStore.clearUserProfileState();
    ProfileStore.clearDealerProfile();
    ProfileStore.clearDealers();
    FavoriteStore.clearState();
    // PLEASE READ COMMENTS ABOVE
    // fetch data for an unathorized user after clean up
    FavoriteStore.getFavoritesIDs();
};
onAuthStateChanged(auth, user => {
    // This method gets invoked in the UI thread on changes in the authentication state:
    // - Right after the listener has been registered
    // - When a user is signed in
    // - When the current user is signed out
    // - When the current user changes
    user ? doSignIn(user) : doSignOut(user);
});
export { auth, EmailAuthProvider, tokenUpdateAffect };
